import React from "react";
import { Button } from "@mtm/components";
import "antd/dist/antd.css";
import { resetUserPassword } from "../../services/RegistrationService";
import { ReCaptcha } from "../ReCaptcha/ReCaptcha";
import { RegistrationComponentLoad } from "../../types/ApplicationTypes";
import Styles from "./SingleWandaEmailValidation.module.scss";

type Props = {
  wandaEmailId: string;
  personId: number;
  setPageType: Function;
};

const SingleWandaEmailValidation: React.FC<Props> = ({
  wandaEmailId,
  personId,
  setPageType,
}) => {
  async function handleResetPassword(execute: () => Promise<string>) {
    const token = await execute();
    const data = {
      emailId: wandaEmailId,
      recaptchaToken: token,
    };
    try {
      const result = await resetUserPassword(data);
      if (result.success === true) {
        setPageType(RegistrationComponentLoad.ResetPassword);
      }
    } catch (error) {
      console.log("Could not send reset email");
    }
  }

  async function handleReturnToLogin() {
    window.location.hash = `/`;
    window.location.reload();
  }

  return (
    <>
      <div className="container">
        <div className={Styles.WandaEmailValidation}>
          <span>Account Already Exists</span>
          <p className="subTextFont">
            Based on the information you entered in the last step, it looks like
            you already have a Wanda account:
          </p>
          <h2 className="subTextFont">{wandaEmailId}</h2>
          <h1 className="subTextFont">
            Please login using the email address above to continue configuring
            your Wanda user account.
          </h1>
          <div className={Styles.WandaEmailButtonAlign}>
            <ReCaptcha>
              {(captcha) => (
                <>
                  <div className="zipModalButton">
                    <Button
                      clickHandler={(e) => handleResetPassword(captcha.execute)}
                      className="cancelBtn"
                      key="close"
                    >
                      Reset Password
                    </Button>
                  </div>
                  <div className="zipModalButtonSignup">
                    <Button
                      clickHandler={handleReturnToLogin}
                      className="saveBtn"
                      key="close"
                    >
                      Return to Login
                    </Button>
                  </div>
                </>
              )}
            </ReCaptcha>
          </div>
        </div>
      </div>
    </>
  );
};
export default SingleWandaEmailValidation;
